import { render } from "./HsActionMenu.vue?vue&type=template&id=036c5ab8&scoped=true"
import script from "./HsActionMenu.vue?vue&type=script&lang=js"
export * from "./HsActionMenu.vue?vue&type=script&lang=js"

import "./HsActionMenu.vue?vue&type=style&index=0&id=036c5ab8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036c5ab8"]])

export default __exports__